export default __webpack_public_path__ + "TKEType-Regular.woff";